<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container px-0">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Apex Charts</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://apexcharts.com/" target="_black">Apex</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container px-0">

          <!-- Apex: Introduction -->
          <div class="row clearfix">
            <div class="col-xl-4 col-lg-5 col-md-12">
              <div class="card mb-4">
                <div class="card-body">
                  <app-sparklines></app-sparklines>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <app-sparklines></app-sparklines>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <app-sparklines></app-sparklines>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <app-minbar-chart></app-minbar-chart>

                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <app-minbar-chart></app-minbar-chart>
                </div>
              </div>
              <!-- <div class="card mb-4">
                <div class="card-body">
                  <div id="apexspark-chart3"></div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <div id="apexspark-chart4"></div>
                </div>
              </div> -->
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Basic Radar</h6>
                </div>
                <div class="card-body">
                  <app-radar-chart></app-radar-chart>
                </div>
              </div>
              <!-- <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Radar Multiple Series</h6>
                </div>
                <div class="card-body">
                  <div id="apex-radar-multiple-series"></div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Radar with Polygon Fill</h6>
                </div>
                <div class="card-body">
                  <div id="apex-radar-polygon-fill"></div>
                </div>
              </div> -->
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Simple Donut</h6>
                </div>
                <div class="card-body">
                  <app-pie-chart></app-pie-chart>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Circle Chart</h6>
                </div>
                <div class="card-body">
                  <app-basicradar-chart></app-basicradar-chart>
                </div>
              </div>
              <!-- <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Circle Chart Multiple</h6>
                </div>
                <div class="card-body">
                  <div id="apex-circle-chart-multiple"></div>
                </div>
              </div> -->
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Circle Gradient</h6>
                </div>
                <div class="card-body">
                  <app-radialbar-chart></app-radialbar-chart>
                </div>
              </div>
              <!-- <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Stroked Gauge</h6>
                </div>
                <div class="card-body">
                  <div id="apex-stroked-gauge"></div>
                </div>
              </div> -->
            </div>
            <div class="col-xl-8 col-lg-7 col-md-12">
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Area Datetime</h6>
                </div>
                <div class="card-body">
                  <div class="btn-group" role="group">
                    <button class="btn btn-sm btn-outline-secondary" id="one_month">1M</button>
                    <button class="btn btn-sm btn-outline-secondary" id="six_months">6M</button>
                    <button class="btn btn-sm btn-outline-secondary" id="one_year" class="active">1Y</button>
                    <button class="btn btn-sm btn-outline-secondary" id="ytd">YTD</button>
                    <button class="btn btn-sm btn-outline-secondary" id="all">ALL</button>
                  </div>
                  <app-line-chart></app-line-chart>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Stacked Area</h6>
                </div>
                <div class="card-body">
                  <app-area-chart></app-area-chart>
                </div>
              </div>
              <!-- <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Timeline</h6>
                </div>
                <div class="card-body">
                  <div id="apex-timeline"></div>
                </div>
              </div> -->
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Basic Bar</h6>
                </div>
                <div class="card-body">
                  <app-bar-chart></app-bar-chart>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Basic CandleStick</h6>
                </div>
                <div class="card-body">
                  <app-candlestick-chart></app-candlestick-chart>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Basic Column</h6>
                </div>
                <div class="card-body">
                  <app-column-chart></app-column-chart>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Basic Heatmap Chart</h6>
                </div>
                <div class="card-body">
                  <app-heatmap-chart></app-heatmap-chart>
                </div>
              </div>
              <!-- <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Basic Scatter Chart</h6>
                </div>
                <div class="card-body">
                  <div id="apex-basic-scatter"></div>
                </div>
              </div> -->
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Basic Line Column</h6>
                </div>
                <div class="card-body">
                  <app-column-line-chart></app-column-line-chart>
                </div>
              </div>
              <!-- <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Simple Bubble</h6>
                </div>
                <div class="card-body">
                  <div id="apex-simple-bubble"></div>
                </div>
              </div> -->
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
